export const Config = {
    apiKey: "AIzaSyBENToflVxl-7VP-O7ax8wkU93bdWS8Oo0",
    authDomain: "rapidpay-f5864.firebaseapp.com",
    databaseURL: "https://rapidpay-f5864.firebaseio.com",
    projectId: "rapidpay-f5864",
    storageBucket: "rapidpay-f5864.appspot.com",
    messagingSenderId: "859998730085",
    appId: "1:859998730085:web:b40ccf369050d002"
  };